import type { FormLayoutPage } from '../../../../../forms'
import { layoutFields } from './helpers'

export const BasicInfoLayout: FormLayoutPage = {
  key: 'basic-info',
  title: 'Basic Information',
  description: 'Enter the basic details about the building and elevator unit.',
  contents: [
    {
      key: 'site-selection',
      type: 'sub-section',
      title: 'Site Selection',
      fields: [layoutFields.siteId],
    },
    {
      key: 'building-details',
      type: 'sub-section',
      title: 'Building Details',
      fields: [
        layoutFields.ahjId,
        layoutFields.buildingDesignation,
        layoutFields.manufacturer,
        layoutFields.manufacturerSerial,
      ],
    },
    {
      key: 'mcp-details',
      type: 'sub-section',
      title: 'MCP Details',
      fields: [
        layoutFields.startDateMonth,
        layoutFields.startDateYear,
        layoutFields.surveyor,
      ],
    },
  ],
}
